import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import Index from '@/pages/index'
import Login from '@/pages/login'
import Form from '@/pages/form'

import Disclaim from '@/pages/disclaim'
import UserCenter from '@/pages/user_center'
import Playing from '@/pages/playing'


Vue.use(Router)

let router =  new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/form',
      name: 'Form',
      component: Form
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    {
      path: '/disclaim',
      name: 'Disclaim',
      component: Disclaim
    },
    {
      path: '/user_center',
      name: 'UserCenter',
      component: UserCenter
    },
    {
      path: '/playing',
      name: 'Playing',
      component: Playing
    },

  ]
})

// 在你的router/index.js或者router.js文件中
router.beforeEach((to, from, next) => {
  // console.log('to :>> ', to);
  // console.log('from :>> ', from);
  next()
  // 检查是否为刷新页面（即from.path为空或undefined）
  // if (from.path === '' || from.path === undefined) {
  //   next('/'); // 重定向到首页
  // } else {
  //   next(); // 继续导航到目标路由
  // }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js